var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),(_vm.showGlasses)?_c('img',{attrs:{"alt":"Glasses logo","src":require("./assets/glasses.svg")}}):_vm._e(),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }